<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>watch-time</title>
    <path
      d="M20,12a8.005,8.005,0,0,0-4-6.926V1.5A1.5,1.5,0,0,0,14.5,0h-5A1.5,1.5,0,0,0,8,1.5V5.075A8,8,0,0,0,8,18.927V22.5A1.5,1.5,0,0,0,9.5,24h5A1.5,1.5,0,0,0,16,22.5V18.927A8.006,8.006,0,0,0,20,12Zm-8,6a6,6,0,1,1,6-6A6.007,6.007,0,0,1,12,18Z"
    />
    <path d="M12.75,11.69V9a.75.75,0,1,0-1.5,0v3a.749.749,0,0,0,.22.53l2.5,2.5a.77.77,0,0,0,1.06,0,.749.749,0,0,0,0-1.06Z" />
  </svg>
</template>
